import { gql } from '@apollo/client';

export const POS_CONFIG_QUERY = gql`
  query PosConfig {
    posConfig {
      single_station_mode_enabled
      demo_mode_enabled
    }
  }
`;
